import React,{useEffect, useRef} from 'react'

import { useState } from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';

import LedgerGroupForm from '../components/LedgerGroupFrom';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';


const CellActions = (props) =>{
    return(
        <>
            <LedgerGroupForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function LedgerGroupGroupListPage() {

  const {getMasterLabel} = useAppData()
  const {ledgerGroupList,getLedgerGroupList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"title",headerName: "Ledger Group Name",width:250},
        {field:"title",headerName: "Nature",width:250, valueGetter: params => getMasterLabel("ledger-group-nature", params.data.nature)},
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <FinanceLayout>
      <div className='row'>
        <div className='col-md-6'><h4>LedgerGroups</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><LedgerGroupForm callBack={getLedgerGroupList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 650}}>
              <AgGridReact
                ref={gridRef}
                rowData={ledgerGroupList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getLedgerGroupList}
              />
            </div>
          </div>
        </div>
    </FinanceLayout>
    
  )
}

export default LedgerGroupGroupListPage